import { render } from "./remoteaccess.vue?vue&type=template&id=4be7f5d4"
import script from "./remoteaccess.vue?vue&type=script&lang=js"
export * from "./remoteaccess.vue?vue&type=script&lang=js"

import "./remoteaccess.vue?vue&type=style&index=0&id=4be7f5d4&lang=less"
script.render = render

export default script